import { Grid } from '@mui/material';
import * as Yup from 'yup';

import { RHFAutocomplete, RHFTextField } from '@components/HookForm';

import { ICountries, countries } from '@src/resources/countries';

export interface AddressFormValues {
  countryCode: ICountries;
  addressLine1: string;
  addressLine2?: string;
  locality: string;
  administrativeArea: string;
  postalCode: string;
}

export const addressFormValidationSchema = Yup.object().shape({
  countryCode: Yup.object({
    code: Yup.string().required(),
    label: Yup.string().required(),
    phone: Yup.string().required(),
  }).required('Country is required'),
  addressLine1: Yup.string().required('Street address is required'),
  addressLine2: Yup.string(),
  locality: Yup.string().required('City is required'),
  administrativeArea: Yup.string().required('State is required'),
  postalCode: Yup.string()
    .required('Zip code is required')
    .when('countryCode', {
      is: (country?: ICountries) => country?.code === 'US',
      then: (schema) => schema.matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Must be 5 or 9 digits'),
    }),
});

export const AddressFormFields = () => {
  return (
    <Grid container spacing={3} sx={{ m: 0 }}>
      <Grid size={{ xs: 12 }}>
        <RHFAutocomplete
          name="countryCode"
          label="Country"
          options={countries}
          isOptionEqualToValue={(option, value) => option.code === value.code}
        />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <RHFTextField name="addressLine1" label="Street Address" required />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <RHFTextField name="addressLine2" label="Street Address Line 2" />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <RHFTextField name="locality" label="City" required />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <RHFTextField name="administrativeArea" label="State / Province" required />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <RHFTextField name="postalCode" label="Postal / Zip Code" required />
      </Grid>
    </Grid>
  );
};
